import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_AccountingPlanEditor = _resolveComponent("AccountingPlanEditor")!
  const _component_ScopeManager = _resolveComponent("ScopeManager")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: "",
    class: "pb-0 mb-0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "default_card large mx-0 my- fill-height",
        elevation: "0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "4",
                class: "d-flex justify-start align-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_back, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back()))
                  }),
                  _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "ml-2" }, "Plan Comptable", -1))
                ]),
                _: 1
              }),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "d-flex align-center justify-end"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    rounded: "",
                    elevation: "0",
                    class: "ml-2",
                    disabled: _ctx.isDisabled,
                    loading: _ctx.importLoading,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.upsertAccountingPlan()))
                  }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode(" Enregistrer ")
                    ])),
                    _: 1
                  }, 8, ["disabled", "loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        style: _normalizeStyle('max-height:' + _ctx.maxHeight + ';' + 'overflow:auto')
      }, [
        _createVNode(_component_AccountingPlanEditor, {
          ref: "editor",
          onOnValidChanged: _ctx.onValidChanged,
          onSetScope: _ctx.toSetScope,
          onScopeReadonly: _ctx.setReadonly
        }, null, 8, ["onOnValidChanged", "onSetScope", "onScopeReadonly"]),
        _createVNode(_component_ScopeManager, {
          modelValue: _ctx.scopeSync,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.scopeSync) = $event)),
          id: _ctx.scopeId,
          "onUpdate:id": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.scopeId) = $event)),
          name: _ctx.scopeName,
          "onUpdate:name": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.scopeName) = $event)),
          hideCompany: true,
          readonly: _ctx.readonly
        }, null, 8, ["modelValue", "id", "name", "readonly"])
      ], 4)
    ]),
    _: 1
  }))
}